import AgendaBoxListPage from "./pages/AgendaBoxListPage.vue";
export default {
     AgendaBoxListPage 
};
